export interface StatFigureProps {
  value: number | string;
  /** A quiet label read after the figure, such as "applications". */
  label: string;
  className?: string;
}

/** The headline number treatment: a large figure over a quiet label, never beside it. */
export function StatFigure({ value, label, className = "" }: StatFigureProps) {
  return (
    <div className={`flex flex-col gap-2 ${className}`}>
      <span className="text-[44px] font-semibold leading-none tracking-tight tabular-nums text-(--fg-primary)">
        {value}
      </span>
      <span className="text-[13px] font-medium text-(--fg-secondary)">
        {label}
      </span>
    </div>
  );
}
